import React from "react";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _2200px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

import arrowImage from "../../assets/image/arrow.png";
import { logDOM } from "@testing-library/react";
import { baseUrl } from "../../utils/base_url";
import { Carousel } from "react-bootstrap";

const Solo_practitionersSecond = ({
  isMobile,
  rightbg,
  leftbg,
  mainclassright,
  mainclassleft,
  leftheading,
  leftsubheading,
  rightheading,
  rightsubheading,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });

  return (
    <>
      <div className="row">
        <div
          className={mainclassleft}
          style={{
            backgroundColor: leftbg,
            // padding: "0 13.5rem 2rem 0rem",
            // paddingLeft: isMobile ? "" : "6rem",
            // paddingRight: isMobile ? "" : "3rem",
            // paddingBottom: isMobile ? "" : "2rem",
            // height: "1081px",
            height: _1200 ? "50vh" : "95vh",
          }}
        >
          <div className="text-center text-md-start container contwidth ">
            <p
              className={`fw900 ${isMobile ? "fs40" : "fs80"}  text-white mb-3`}
              style={{ lineHeight: isMobile ? "" : "4.4rem" }}
            >
              {leftheading}
            </p>
            <p
              className={`fw400 ${isMobile ? "fs20" : "fs35"} text-white`}
              style={{ lineHeight: isMobile ? "" : "2rem" }}
            >
              {leftsubheading}
            </p>
          </div>
        </div>

        <div
          // className="col-12 col-lg-6 d-flex flex-column justify-content-end align-items-start"\
          className={mainclassright}
          style={{
            backgroundColor: rightbg,
            padding: isMobile ? " " : "0 13rem 2rem 4rem",
            textAlign: isMobile ? "center" : "",
            // height: "1081px",
            height: _1200 ? "50vh" : "95vh",
          }}
        >
          <div className="text-center text-md-start ">
            <p
              //  dangerouslySetInnerHTML={{
              //   __html: rightheading?.replace("Case n", "Case<br/>"),
              // }}
              className={`fw900 ${isMobile ? "fs40" : "fs80"}  text-white mb-3`}
              style={{ lineHeight: isMobile ? "" : "4.4rem" }}
            >
              {rightheading}
            </p>
            <p
              className={`fw400 ${isMobile ? "fs20" : "fs35"} text-white`}
              style={{ lineHeight: isMobile ? "" : "2rem" }}
            >
              {rightsubheading}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Solo_practitionersSecond;

export const SoloPractitionersSecond = ({
  isMobile,
  staticBg,
  bg,
  mainclassright,
  mainclassleft,
  heading,
  subheading,
  rightheading,
  rightsubheading,
  left,
  mapping,
  imgsrc,
  index,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });

  return (
    <div className="row  gx-0">
      <div className={mainclassleft}>
        <div
          // className="bg-danger "
          style={{
            paddingLeft: left
              ? _576
                ? "1.3rem" //"2.3rem"
                : _768
                ? "2.3rem" //"4rem"
                : _992
                ? "3rem"
                : _1200
                ? "6rem"
                : _1400
                ? "8.7rem"
                : _1500
                ? "8.7rem"
                : _1600
                ? "9.3rem"
                : _1700
                ? "10.3rem"
                : _1800
                ? "10.5rem"
                : _2200
                ? "12rem"
                : "12rem"
              : "",
            backgroundColor: left ? bg : staticBg,
            // height: "1081px",
            height: _1200 ? "50vh" : "95vh",
            paddingBottom: left ? (_1200 ? "0" : "3rem") : "",
            paddingRight: left ? "3rem" : "",
          }}
          className={`d-flex flex-column ${
            left ? (_576 ? "" : _1200 ? (mapping ? "pb-3" : "") : "") : ""
          } ${
            _768
              ? "justify-content-center align-items-center"
              : "justify-content-end align-items-start"
          }`}
        >
          {left && (
            <HeadingSection
              heading={heading}
              mapping={mapping}
              subheading={subheading}
              imgsrc={imgsrc}
              index={index}
            />
          )}

          {_992
            ? !left && (
                <HeadingSection
                  mapping={mapping}
                  heading={heading}
                  subheading={subheading}
                />
              )
            : ""}

          {_992
            ? ""
            : !left &&
              // <img
              //   src={`${baseUrl}${imgsrc}`}
              //   style={{ width: "100%", height: "100%" }}
              // />
              // (imgsrc?.mime?.includes("video") ? (
              //   <div
              //     style={{
              //       height: "100%",
              //       width: "100%",
              //     }}
              //   >
              //     <video
              //       autoPlay
              //       loop
              //       muted
              //       className=""
              //       style={{
              //         // objectFit: "cover",
              //         height: "100%",
              //         width: "100%",
              //         // borderRadius: "20px",
              //       }}
              //     >
              //       <source src={`${baseUrl}${imgsrc?.url}`} type="video/mp4" />
              //       Your browser does not support the video tag.
              //     </video>
              //   </div>
              // ) : (
              //   <img
              //     className="d-block"
              //     style={{
              //       // objectFit: "cover",
              //       width: "100%",
              //       height: "100%",
              //       // borderRadius: "20px",
              //     }}
              //     src={`${baseUrl}${imgsrc?.url}`}
              //     alt="..."
              //   />
              // ))
              (imgsrc?.length === 1 ? (
                imgsrc[0]?.mime?.includes("video") ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <video
                      autoPlay
                      loop
                      muted
                      className=""
                      style={{
                        // objectFit: "cover",
                        height: "100%",
                        width: "100%",
                        // borderRadius: "20px",
                      }}
                    >
                      <source
                        src={`${baseUrl}${imgsrc[0]?.url}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <img
                    className="d-block"
                    style={{
                      // objectFit: "cover",
                      width: "100%",
                      height: "100%",
                      // borderRadius: "20px",
                    }}
                    src={`${baseUrl}${imgsrc[0]?.url}`}
                    alt="..."
                  />
                )
              ) : (
                <Carousel
                  pause={false}
                  indicators={false}
                  interval={5000}
                  controls={false}
                >
                  {imgsrc?.map((image, idx) => (
                    <Carousel.Item
                      key={idx}
                      className="position-relative vh-100"
                    >
                      {image?.mime?.includes("video") ? (
                        <div style={{ height: "100%", width: "100%" }}>
                          <video
                            autoPlay
                            loop
                            muted
                            style={{
                              objectFit: "cover",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <source
                              src={`${baseUrl}${image?.url}`}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <img
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          src={`${baseUrl}${image?.url}`}
                          alt="..."
                        />
                      )}
                    </Carousel.Item>
                  ))}
                </Carousel>
              ))}

          {/* <div className="text-center text-md-start  container  contwidth ">
            <p
              className={`fw900 ${isMobile ? "fs40" : "fs80"}  text-white mb-3`}
              style={{ lineHeight: isMobile ? "" : "4.4rem" }}
            >
              {leftheading}
            </p>
            <p
              className={`fw400 ${isMobile ? "fs20" : "fs35"} text-white`}
              style={{ lineHeight: isMobile ? "" : "2rem" }}
            >
              {leftsubheading}
            </p>
          </div> */}
        </div>
      </div>
      <div className={mainclassleft}>
        <div
          // className="bg-warning "
          style={{
            // paddingLeft: "4rem",
            backgroundColor: left ? staticBg : bg,
            paddingLeft: left
              ? ""
              : _576
              ? "1.3rem"
              : _768
              ? "2.3rem"
              : _992
              ? "3rem"
              : "4rem",
            paddingBottom: left ? "" : _1200 ? "0" : "4rem",
            // height: "1081px",
            height: _1200 ? "50vh" : "95vh",
            paddingRight: left ? "" : _576 ? "1rem" : "4rem",
          }}
          className={`d-flex flex-column ${
            left ? "" : _1200 ? (mapping ? "pb-3" : "") : ""
          } ${
            _768
              ? "justify-content-center align-items-center"
              : "justify-content-end align-items-start"
          }`}
        >
          {_992
            ? ""
            : !left && (
                <HeadingSection
                  mapping={mapping}
                  heading={heading}
                  subheading={subheading}
                />
              )}

          {left &&
            // <img src={`${baseUrl}${imgsrc}`} style={{width:"100%", height:"100%"}}/>
            // (imgsrc?.mime?.includes("video") ? (
            //   <div
            //     style={{
            //       height: "100%",
            //       width: "100%",
            //     }}
            //   >
            //     <video
            //       autoPlay
            //       loop
            //       muted
            //       className=""
            //       style={{
            //         objectFit: "cover",
            //         height: "100%",
            //         width: "100%",
            //         // borderRadius: "20px",
            //       }}
            //     >
            //       <source src={`${baseUrl}${imgsrc?.url}`} type="video/mp4" />
            //       Your browser does not support the video tag.
            //     </video>
            //   </div>
            // ) : (
            //   <img
            //     className="d-block"
            //     style={{
            //       objectFit: "cover",
            //       width: "100%",
            //       height: "100%",
            //       // borderRadius: "20px",
            //     }}
            //     src={`${baseUrl}${imgsrc?.url}`}
            //     alt="..."
            //   />
            // ))
            (imgsrc?.length === 1 ? (
              imgsrc[0]?.mime?.includes("video") ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <video
                    autoPlay
                    loop
                    muted
                    className=""
                    style={{
                      // objectFit: "cover",
                      height: "100%",
                      width: "100%",
                      // borderRadius: "20px",
                    }}
                  >
                    <source
                      src={`${baseUrl}${imgsrc[0]?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <img
                  className="d-block"
                  style={{
                    // objectFit: "cover",
                    width: "100%",
                    height: "100%",
                    // borderRadius: "20px",
                  }}
                  src={`${baseUrl}${imgsrc[0]?.url}`}
                  alt="..."
                />
              )
            ) : (
              <Carousel
                pause={false}
                indicators={false}
                interval={5000}
                controls={false}
              >
                {imgsrc?.map((image, idx) => (
                  <Carousel.Item key={idx} className="position-relative vh-100">
                    {image?.mime?.includes("video") ? (
                      <div style={{ height: "100%", width: "100%" }}>
                        <video
                          autoPlay
                          loop
                          muted
                          style={{
                            objectFit: "cover",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <source
                            src={`${baseUrl}${image?.url}`}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ) : (
                      <img
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={`${baseUrl}${image?.url}`}
                        alt="..."
                      />
                    )}
                  </Carousel.Item>
                ))}
              </Carousel>
            ))}

          {_992
            ? !left &&
              // <img src={`${baseUrl}${imgsrc}`} style={{width:"100%", height:"100%"}}/>
              // (imgsrc?.mime?.includes("video") ? (
              //   <div
              //     style={{
              //       height: "100%",
              //       width: "100%",
              //     }}
              //   >
              //     <video
              //       autoPlay
              //       loop
              //       muted
              //       className=""
              //       style={{
              //         objectFit: "cover",
              //         height: "100%",
              //         width: "100%",
              //         // borderRadius: "20px",
              //       }}
              //     >
              //       <source src={`${baseUrl}${imgsrc?.url}`} type="video/mp4" />
              //       Your browser does not support the video tag.
              //     </video>
              //   </div>
              // ) : (
              //   <img
              //     className="d-block"
              //     style={{
              //       objectFit: "cover",
              //       width: "100%",
              //       height: "100%",
              //       // borderRadius: "20px",
              //     }}
              //     src={`${baseUrl}${imgsrc?.url}`}
              //     alt="..."
              //   />
              // ))
              (imgsrc?.length === 1 ? (
                imgsrc[0]?.mime?.includes("video") ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <video
                      autoPlay
                      loop
                      muted
                      className=""
                      style={{
                        // objectFit: "cover",
                        height: "100%",
                        width: "100%",
                        // borderRadius: "20px",
                      }}
                    >
                      <source
                        src={`${baseUrl}${imgsrc[0]?.url}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <img
                    className="d-block"
                    style={{
                      // objectFit: "cover",
                      width: "100%",
                      height: "100%",
                      // borderRadius: "20px",
                    }}
                    src={`${baseUrl}${imgsrc[0]?.url}`}
                    alt="..."
                  />
                )
              ) : (
                <Carousel
                  pause={false}
                  indicators={false}
                  interval={5000}
                  controls={false}
                >
                  {imgsrc?.map((image, idx) => (
                    <Carousel.Item
                      key={idx}
                      className="position-relative vh-100"
                    >
                      {image?.mime?.includes("video") ? (
                        <div style={{ height: "100%", width: "100%" }}>
                          <video
                            autoPlay
                            loop
                            muted
                            style={{
                              objectFit: "cover",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <source
                              src={`${baseUrl}${image?.url}`}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <img
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          src={`${baseUrl}${image?.url}`}
                          alt="..."
                        />
                      )}
                    </Carousel.Item>
                  ))}
                </Carousel>
              ))
            : ""}

          {/* <div className="text-center text-md-start ">
            <p
              className={`fw900 ${isMobile ? "fs40" : "fs80"}  text-white mb-3`}
              style={{ lineHeight: isMobile ? "" : "4.4rem" }}
            >
              {rightheading}
            </p>
            <p
              className={`fw400 ${isMobile ? "fs20" : "fs35"} text-white`}
              style={{ lineHeight: isMobile ? "" : "2rem" }}
            >
              {rightsubheading}
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const HeadingSection = ({ heading, subheading, mapping, index }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });
  return (
    <div
      style={{
        color: "#fff",
      }}
    >
      <p
        dangerouslySetInnerHTML={{
          __html: heading
            ?.replace(/Smart/g, "<br/>Smart")
            ?.replace(/Case n/g, "Case<br/>"),
        }}
        style={{
          fontWeight: "900",
          fontSize: _576
            ? "36px"
            : _768
            ? "40px"
            : _992
            ? "50px"
            : _1200
            ? "40px"
            : _1400
            ? "60px"
            : _1500
            ? "65px"
            : _1600
            ? "70px"
            : _1700
            ? "78px"
            : _1800
            ? "90px"
            : _2200
            ? "90px"
            : "90px",
          lineHeight: _576
            ? "50px"
            : _768
            ? "50px"
            : _992
            ? "50px"
            : _1200
            ? "50px"
            : _1400
            ? "60px"
            : _1500
            ? "60px"
            : _1600
            ? "80px"
            : _1700
            ? "87px"
            : _1800
            ? "100px"
            : _2200
            ? "100px"
            : "100px",
        }}
        className="lh-sm"
      >
        {/* {heading} */}
      </p>

      {mapping ? (
        <>
          {subheading?.map((item, index) => (
            <div className="d-flex flex-column align-items-start">
              {item?.children?.map((child, j) =>
                child?.children?.map((textItem, k) => (
                  <>
                    <div className="d-flex align-items-start pt-2">
                      <img
                        src={arrowImage}
                        style={{ width: "21px", height: "20px" }}
                        className="me-3"
                      />
                      <p
                        style={{
                          fontWeight: "400",
                          fontSize: _576
                            ? "14px"
                            : _768
                            ? "14px"
                            : _992
                            ? "14px"
                            : _1200
                            ? "16px"
                            : _1400
                            ? "18px"
                            : _1500
                            ? "18px"
                            : _1600
                            ? "18px"
                            : _1700
                            ? "23px"
                            : _1800
                            ? "24px"
                            : _2200
                            ? "24px"
                            : "24px",
                          lineHeight: _576
                            ? "20px"
                            : _768
                            ? "24px"
                            : _992
                            ? "24px"
                            : _1200
                            ? "24px"
                            : _1400
                            ? "24px"
                            : _1500
                            ? "24px"
                            : _1600
                            ? "20px"
                            : _1700
                            ? "24px"
                            : _1800
                            ? "24px"
                            : _2200
                            ? "24px"
                            : "24px",
                        }}
                        className={`${_1200 ? `pb-0 mb-0` : "pb-2"}`}
                      >
                        {textItem?.text}
                      </p>
                    </div>
                  </>
                ))
              )}
            </div>
          ))}
        </>
      ) : (
        <p
          style={{
            fontWeight: "400",
            fontSize: _576
              ? "18px"
              : _768
              ? "20px"
              : _992
              ? "20px"
              : _1200
              ? "20px"
              : _1400
              ? "25px"
              : _1500
              ? "25px"
              : _1600
              ? "28px"
              : _1700
              ? "35px"
              : _1800
              ? "40px"
              : _2200
              ? "40px"
              : "40px",
            lineHeight: _576
              ? "19px"
              : _768
              ? "20px"
              : _992
              ? "20px"
              : _1200
              ? "20px"
              : _1400
              ? "25px"
              : _1500
              ? "25px"
              : _1600
              ? "28px"
              : _1700
              ? "40px"
              : _1800
              ? "40px"
              : _2200
              ? "40px"
              : "40px",
          }}
        >
          {subheading}
        </p>
      )}
    </div>
  );
};
